<template>
  <div id="App">

    <div class="head-top" style="background-color: #f9f9f9;border-bottom: 1px solid #f2f2f2;">
      <div id="w-center" class="hede-top-won" style=" height: 34px;">

        
		<!-- <img :src="info.logo" alt="" class="logo_imng"> -->
		<span style="line-height: 34px;"><a style="color: red;">{{user.name}}</a>您好，欢迎光临</span>
		<div style="width: 31%;float: right;">
			<el-menu
			  :default-active="activeIndex"
			  class="el-menu-demo"
			  mode="horizontal"
			  background-color="#f9f9f9"
			  text-color="#000000"
			  active-text-color="#2C7AC2">
			<el-menu-item index="1" ><router-link :to="{path:'/Index',query: {index: 1}}">首页</router-link></el-menu-item>
			<el-menu-item index="2"><router-link :to="{path:'/Goodscart',query: {index: 2}}"> <i class="el-icon-shopping-cart-full"></i> 购物车</router-link></el-menu-item>
			<el-menu-item index="3"><router-link :to="{path:'/Orderlist',query: {index: 3}}">订单</router-link></el-menu-item>
			<!-- <el-menu-item index="5"><router-link :to="{path:'/Cglist',query: {memberindex: 9,index: 5}}">采购需求报送</router-link></el-menu-item> -->
			<el-menu-item index="4"><router-link :to="{path:'/Member',query: {index: 4}}">会员中心</router-link></el-menu-item>
			  <el-menu-item @click="logout"><a href="javascript:;">退出</a></el-menu-item>
			</el-menu>
		</div>
		
		
		<!-- <span>
		
		    <el-link :underline="false" @click="logout" >退出登录</el-link>
		    |
		    <router-link :to="`/Member?index=4`">
		        <el-link :underline="false">会员中心</el-link>
		    </router-link>
		</span> -->
		
      </div>
    </div>


      <div class="head">
        <!-- 第一层 -->

      <!--  <div class="">
            <img :src="info.logo" alt="" class="logo_imng">

            <div id="w-center">
                <div id="headtow-nav">
                  <el-menu
                    :default-active="activeIndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    background-color="#2C7AC2"
                    text-color="#ffffff"
                    active-text-color="#ffffff">
					<el-menu-item index="1" ><router-link :to="{path:'/Index',query: {index: 1}}">首页</router-link></el-menu-item>
					<el-menu-item index="2"><router-link :to="{path:'/Goodscart',query: {index: 2}}">购物车</router-link></el-menu-item>
					<el-menu-item index="3"><router-link :to="{path:'/Orderlist',query: {index: 3}}">在线订单</router-link></el-menu-item>
					<el-menu-item index="5"><router-link :to="{path:'/Cglist',query: {memberindex: 9,index: 5}}">采购需求报送</router-link></el-menu-item>
					<el-menu-item index="4"><router-link :to="{path:'/Member',query: {index: 4}}">会员中心</router-link></el-menu-item>
                    <el-menu-item @click="logout"><a href="javascript:;">退出登陆</a></el-menu-item>
                  </el-menu>
                </div>
              </div>
        </div> -->



          <!-- 第一层end -->

          <!-- 导航 -->
       <!--   <div id="w-center" class="ww-center">
            <div id="headtow-nav">
              <el-menu
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                background-color="#2c5fab"
                text-color="#fff"
                active-text-color="#ffc600">
                <el-menu-item index="1"><router-link :to="{path:'/Index',query: {index: 1}}">图书列表</router-link></el-menu-item>
                <el-menu-item index="2"><router-link :to="{path:'/Goodscart',query: {index: 2}}">购物车</router-link></el-menu-item>
                <el-menu-item index="3"><router-link :to="{path:'/Orderlist',query: {index: 3}}">我的订单</router-link></el-menu-item>
                 <el-menu-item index="4"><router-link :to="{path:'/Member',query: {index: 4}}">会员中心</router-link></el-menu-item>

               <el-menu-item index="8"><router-link :to="{path:'/Qiyelist',query: {index: 8}}">企业库</router-link></el-menu-item>
                <el-menu-item index="3"><router-link :to="{path:'/Expert',query: {index: 3}}">专家服务</router-link></el-menu-item>
                <el-menu-item index="4"><router-link :to="{path:'/News',query: {index: 4}}">新闻资讯</router-link></el-menu-item>
                <el-menu-item index="5"><router-link :to="{path:'/Jobs',query: {index: 5}}">论坛交流</router-link></el-menu-item>
                <el-menu-item index="6"><router-link :to="{path:'/About',query: {index: 6}}">平台介绍</router-link></el-menu-item>
                <el-menu-item index="7"><router-link :to="{path:'/Aboutlx',query: {index: 7,id:19}}">联系平台</router-link></el-menu-item>
              </el-menu>
            </div>
          </div> -->
      </div>

  </div>
</template>
<script>
  export default{
    data(){
      return {
        info:[],
        activeIndex: '0',
        keyword:'',
        pieces:[],
        select:'1',
        userid:0,
        user:[],
      }
    },

   mounted () {
     let index = this.$route.query.index
     this.activeIndex = index
     this.recordapi();
   },
   methods:{
     sou(e){
       this.$router.push('/Products?index=2&keyword='+e)
       this.$emit('sou')
     },

     logout(){
        console.log(1);
          this.$confirm('确定要退出登录吗?', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
            }).then(() => {
              this.$message({
                 type: 'success',
                 message: '退出成功!'
               });
               //确认退出，清除token
              this.$cookieStore.delCookie('userid');
              // localStorage.removeItem('token')
               //跳转登录页面(编程式导航)
               this.$router.push('/')

          }).catch(() => {
          this.$message({
          type: 'info',
          message: '已取消退出'
          });
        });
      },

     recordapi(){
         var that = this;
         var userid = that.$cookieStore.getCookie('userid');
         if(userid){
           this.userid = userid;
         }

         that.$api.post("/Login/Loginshow",{'userid':userid}).then(res => {
           console.log(res);
           that.info= res;
           that.user= res.user;
           that.pieces= res.pieces;
         });
     },
     sousuo(){
       if(this.select == 1){
          this.$router.push('/Products?index=2&keyword='+this.keyword);
          this.$emit('sou');
       }else if(this.select == 2){
         this.$router.push('/News?index=4&keyword='+this.keyword)
         this.$emit('sou');
       }else if(this.select == 3){
          this.$router.push('/Qiyelist?index=8&keyword='+this.keyword)
          this.$emit('sou');
        }


         // if(this.keyword==''){
         //   this.$message.error('请输入您要搜索的产品');
         //   return
         // }

       // this.$router.push('/Products?index=2&keyword='+this.keyword)

       console.log(this.keyword);
     },
   }

   }
</script>
<style>
	.el-menu-demo{height: 34px !important;}
	.el-menu--horizontal>.el-menu-item{height: 34px !important;line-height: 34px !important;}
</style>



// WEBPACK FOOTER //
// src/components/public/headtow.vue